<template>
  <div class="content-asean-funding container-fluid">
    <div class="row">
      <div class="col-xs-12 col-sm-10 col-sm-offset-1 offset-sm-1 col-md-8 col-md-offset-2 offset-md-2 mb-30">
        <div class="content-asean-funding__chart" v-if="content.chart">
          <h3 class="mb-30">
            {{ content.chart.title }} <br />
            <span class="font-weight-light">{{ content.chart.subtitle }}</span>
          </h3>

          <div class="content-asean-funding__chart-legend">
            <p v-for="legend in legend" :key="legend.label" class="legend-item text-legend">
              <span :style="{ backgroundColor: legend.color }" /> {{ legend.label }}
            </p>
          </div>
        </div>
        <LineChartViz />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AseanFunding',
  components: {
    LineChartViz: () => import('@/components/content/chapter2/charts/LineChartViz.vue'),
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      legend: [
        { label: 'APAC (excluding ASEAN)', color: '#FDC4D0' },
        { label: 'ASEAN', color: '#005EB8' },
        { label: 'Europe', color: '#F09252' },
        { label: 'North America', color: '#E25A5F' },
        { label: 'Rest of the world', color: '#F6C76A' },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.content-asean-funding {
  .content-asean-funding__intro {
    padding: 60px 0;

    .funding-intro__prelude {
      p:last-child {
        margin-bottom: 0;
      }
    }
  }

  .content-asean-funding__chart {
    h3 {
      font-size: 22px;
      line-height: 1.45;
      font-weight: 700;
    }
    
    padding-top: 48px;
    &-legend {
      margin-top: 20px;
      margin-bottom: 15px;

      p.legend-item {
        span {
          width: 20px;
          height: 3px;
          display: inline-block;
          vertical-align: middle;
          margin-right: 5px;
        }
        display: inline-block;
        margin-right: 24px;
        min-width: 215px;
      }
      p.legend-item:last-child {
        margin-right: unset;
      }

      p.legend-item:first-child {
        max-width: unset;
        min-width: 215px;
        margin-right: 24px;
      }
    }
  }

  @media #{map-get($media-breakpoints, 'mobile')} {
    .content-asean-funding__intro {
      padding: 30px 0;
    }

    .content-asean-funding__chart {
      padding: 30px 0;
    }

    .content-asean-funding__chart-legend {
      margin-bottom: 0;

      p.legend-item {
        width: 180px;
        min-width: 180px;
        margin-right: 0px !important;
        span {
          margin-right: 3px;
        }
      }

      p.legend-item:first-child {
        max-width: 300px;
        min-width: 300px;
        margin-right: 0px;
      }
    }
  }
}
</style>
